import { render } from "./CreateGroupPromoCodeModal.vue?vue&type=template&id=08c3e013&scoped=true"
import script from "./CreateGroupPromoCodeModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupPromoCodeModal.vue?vue&type=script&lang=js"

import "./CreateGroupPromoCodeModal.vue?vue&type=style&index=0&id=08c3e013&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c3e013"]])

export default __exports__